
/**
 * 라벨용지 클래스
 */
export class Label {
    constructor(options) {

        // 용지 ID
        this.id = '';

        // 용지이름
        this.name = '';

        // 무지여부 true: 무지, false: 용지에 선있음
        this.emptyLine = true;
        
        // 실제용지 사이즈 (출력영역 바깥쪽, 스티커를떼기전 용지의 전체사이즈)
        this.size = {width: 0, height: 0};

        // 출력영역 사이즈 (스티커를 떼고나서의 용지의 사이즈, 화면에 라벨사이즈를 표시할때 사용)
        this.stickySize = {width: 0, height: 0};

        // 출력 마진 (실제용지 사이즈를 기준으로한 마진값, 마진을 적절히줘야 정상출력됨. 잘 모르겠으면 2mm정도주면됨)
        this.margins = {top: 0, right: 0, bottom: 0, left: 0};
        
        // 단위
        this.units = 'mm'; 


        if (options) {
            Object.assign(this, options);
        }


        // 용지제목
        this.title = this.getTitle();
    }

    /**
     * 사용자에게 표시할 용지제목
     * - 이름, 사이즈로 구성
     */
    getTitle() {
        return `${this.name} ${this.stickySize.width}${this.units} X ${this.stickySize.height}${this.units}`;
    }

    /**
     * qz 설정객체에 들어가는 options 작성
     * - e.g. qz.configs.create('프린터명', options)
     */
    makeQzConfigOptions() {
        return {
            size: this.size,
            units: this.units,
            margins: this.margins,
        };
    }


    /**
     * 문자열로 변경
     * @returns {*}
     */
    toString() {
        return this.title;
    }
}